import { IconButton, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { SolvTheme, SolvThemeProvider } from '@solvhealth/jigsaw-v1';
import history from '../../core/history';
import { ReviewContext } from '../../routes/addReview/context';

const useStyles = makeStyles(() => ({
  closeButton: {
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: SolvTheme.colors['gray-400'],
  },
}));

const ReviewHeaderBase = () => {
  const classes = useStyles();
  const { isModal } = useContext(ReviewContext)!;

  return (
    (isModal && (
      <SolvThemeProvider>
        <IconButton className={classes.closeButton} onClick={() => history.goBack()}>
          <CloseIcon />
        </IconButton>
      </SolvThemeProvider>
    )) ||
    null
  );
};

export default ReviewHeaderBase;
